import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@navikt/aksel-icons";
import { useRenameCSS } from "../../../theme/Theme.js";
function ScrollButton({ hidden, onClick, dir }) {
    const { cn } = useRenameCSS();
    return (React.createElement("div", { className: cn("navds-tabs__scroll-button", {
            "navds-tabs__scroll-button--hidden": hidden,
        }), onClick: onClick, "aria-hidden": true }, dir === "left" ? React.createElement(ChevronLeftIcon, null) : React.createElement(ChevronRightIcon, null)));
}
export default ScrollButton;
//# sourceMappingURL=ScrollButtons.js.map